<div class="contributors-modal">
  <!-- Close button -->
  <div class="flex justify-end">
    <button type="button" class="close-button" (click)="onClose()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Modal content -->
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title text-text-primary mb-1">
        {{ 'projectInsight.contributorsModal.title' | translate }}
      </h2>
      <p class="text-body-sm text-text-secondary">
        {{ 'projectInsight.contributorsModal.subtitle' | translate : { count: totalContributors() } }}
      </p>
    </div>

    <!-- Loading Spinner -->
    @if (loading()) {
    <div class="loading-container">
      <p-progressSpinner strokeWidth="4" animationDuration=".5s" />
    </div>
    } @else {
    <!-- PrimeNG Table with custom scrolling -->
    <div class="table-container">
      <p-table [value]="contributors()" styleClass="contributors-table">
        <ng-template pTemplate="header">
          <tr>
            <th class="rank-column">
              {{ 'projectInsight.contributorsModal.table.rank' | translate }}
            </th>
            <th class="address-column">
              {{ 'projectInsight.contributorsModal.table.walletAddress' | translate }}
            </th>
            <th class="amount-column">
              <span class="table-header-multiline">{{
                'projectInsight.contributorsModal.table.contributedAmount' | translate
                }}</span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contributor>
          <tr>
            <td class="rank-cell">{{ contributor.rank }}.</td>
            <td class="address-cell">
              <div class="flex items-center justify-center gap-4">
                <span>{{ getTruncatedAddress(contributor.walletAddress) }}</span>
                <div class="flex items-center gap-2">
                  <button type="button" class="icon-button" (click)="onCopyAddress(contributor.walletAddress)"
                    [pTooltip]="'projectInsight.contributorsModal.tooltips.copyAddress' | translate"
                    tooltipPosition="top">
                    <i class="pi pi-copy" style="font-size: 13px"></i>
                  </button>
                  <button type="button" class="icon-button" (click)="onViewOnExplorer(contributor.walletAddress)"
                    [pTooltip]="
                        'projectInsight.contributorsModal.tooltips.viewOnExplorer' | translate
                      " tooltipPosition="top">
                    <i class="pi pi-arrow-up-right" style="font-size: 7px"></i>
                  </button>
                </div>
              </div>
            </td>
            <td class="amount-cell">{{ contributor.contributedAmount }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center text-text-secondary py-8">
              {{ 'projectInsight.contributorsModal.noContributors' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Paginator -->
    @if (totalRecords() > rowsPerPage) {
    <div class="paginator-container">
      <p-paginator [first]="first()" [rows]="rowsPerPage" [totalRecords]="totalRecords()" [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} / {totalRecords}" (onPageChange)="onPageChange($event)" />
    </div>
    }
    }

    <!-- Export Button -->
    <div class="modal-footer">
      <p-button [label]="'projectInsight.contributorsModal.exportList' | translate" icon="pi pi-download"
        class="btn-primary btn-medium w-full" (onClick)="onExportList()" [disabled]="loading()" />
    </div>
  </div>
</div>
